import React from "react";
import { convertStringToElements } from "@vds/html-parsers";
import styled from "styled-components";

import Header from "common-components/Header";
import Container from "common-components/Container";

import { replaceHashValues } from "utils/replaceHashValues";

const AuthorizedAgentNoCustomers = ({
  pageContent: { section_title, section_description },
  agentExpiryDate
}) => (
  <Container>
    <Div>
      <Header>{section_title}</Header>
      {convertStringToElements(
        replaceHashValues(section_description, {
          expirydate: agentExpiryDate
        })
      )}
    </Div>
  </Container>
);

export { AuthorizedAgentNoCustomers };

const Div = styled.div`
  max-width: 596px;

  p {
    padding: 12px 0;
  }
`;
